import { render, staticRenderFns } from "./section-detail.component.html?vue&type=template&id=7d4e722a&scoped=true&external"
import script from "./section-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./section-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./section-detail.component.scss?vue&type=style&index=0&id=7d4e722a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e722a",
  null
  
)

export default component.exports